import React from "react";

const OnboardingFooter = () => {
  return (
    <footer className="w-full bg-white border-t border-slate-200 flex items-center justify-center px-4 py-6 transition-colors duration-300">
      <div className="text-sm text-gray-500 dark:text-gray-400">
        Already have an account?{" "}
        <a
          href="onboarding/signin"
          className="text-red-500 font-bold hover:underline dark:text-red-400"
          style={{ textDecorationThickness: "1px" }}
        >
          Sign in
        </a>
      </div>
    </footer>
  );
};

export default OnboardingFooter;
